import React, { useState } from 'react';

function VariationsTable({ variations, periode1, periode2, onSaveComment }) {
  const [editingRow, setEditingRow] = useState(null);
  const [commentText, setCommentText] = useState('');
  const [auteur, setAuteur] = useState('');

  const handleEditClick = (variation) => {
    setEditingRow(variation.numero_compte);
    setCommentText(variation.commentaire || '');
    setAuteur(variation.auteur || '');
  };

  const handleSaveClick = async (numeroCompte) => {
    const success = await onSaveComment(numeroCompte, commentText, auteur);
    if (success) {
      setEditingRow(null);
      setCommentText('');
      setAuteur('');
    }
  };

  const handleCancelClick = () => {
    setEditingRow(null);
    setCommentText('');
    setAuteur('');
  };

  const formatNumber = (num) => {
    return new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(num);
  };

  const getVariationClass = (variation) => {
    if (variation === 0) return '';
    return variation > 0 ? 'positive' : 'negative';
  };

  return (
    <div className="variations-container">
      <h2>📈 Variations entre {periode1} et {periode2}</h2>
      
      <div className="stats">
        <div className="stat-item">
          <span className="stat-label">Total lignes :</span>
          <span className="stat-value">{variations.length}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Avec commentaires :</span>
          <span className="stat-value">{variations.filter(v => v.commentaire).length}</span>
        </div>
      </div>

      <div className="table-wrapper">
        <table className="variations-table">
          <thead>
            <tr>
              <th>N° Compte</th>
              <th>Libellé</th>
              <th className="number-col">{periode1}</th>
              <th className="number-col">{periode2}</th>
              <th className="number-col">Variation</th>
              <th className="number-col">%</th>
              <th className="comment-col">Commentaire</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {variations.map((variation) => {
              const isEditing = editingRow === variation.numero_compte;
              const variationPct = variation.montant_periode1 !== 0
                ? ((variation.variation / variation.montant_periode1) * 100)
                : 0;

              return (
                <tr key={variation.numero_compte}>
                  <td className="compte-cell">{variation.numero_compte}</td>
                  <td>{variation.libelle_compte}</td>
                  <td className="number-col">{formatNumber(variation.montant_periode1)}</td>
                  <td className="number-col">{formatNumber(variation.montant_periode2)}</td>
                  <td className={`number-col ${getVariationClass(variation.variation)}`}>
                    {formatNumber(variation.variation)}
                  </td>
                  <td className={`number-col ${getVariationClass(variation.variation)}`}>
                    {variationPct !== 0 ? `${formatNumber(variationPct)}%` : '-'}
                  </td>
                  <td className="comment-col">
                    {isEditing ? (
                      <div className="edit-comment">
                        <input
                          type="text"
                          placeholder="Votre nom"
                          value={auteur}
                          onChange={(e) => setAuteur(e.target.value)}
                          className="input-auteur"
                        />
                        <textarea
                          value={commentText}
                          onChange={(e) => setCommentText(e.target.value)}
                          placeholder="Ajouter un commentaire..."
                          rows="2"
                        />
                      </div>
                    ) : (
                      <div className="comment-display">
                        {variation.commentaire ? (
                          <>
                            <div className="comment-text">{variation.commentaire}</div>
                            <div className="comment-meta">
                              <small>
                                Par {variation.auteur} • {new Date(variation.date_modification).toLocaleDateString('fr-FR')}
                              </small>
                            </div>
                          </>
                        ) : (
                          <span className="no-comment">-</span>
                        )}
                      </div>
                    )}
                  </td>
                  <td className="actions-col">
                    {isEditing ? (
                      <div className="action-buttons">
                        <button
                          onClick={() => handleSaveClick(variation.numero_compte)}
                          className="btn-save"
                          disabled={!commentText.trim()}
                        >
                          ✓
                        </button>
                        <button
                          onClick={handleCancelClick}
                          className="btn-cancel"
                        >
                          ✗
                        </button>
                      </div>
                    ) : (
                      <button
                        onClick={() => handleEditClick(variation)}
                        className="btn-edit"
                      >
                        {variation.commentaire ? '✏️' : '➕'}
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {variations.length === 0 && (
          <div className="empty-table">
            Aucune donnée pour ces périodes
          </div>
        )}
      </div>
    </div>
  );
}

export default VariationsTable;
